window.addEventListener('DOMContentLoaded', () => {
    const logo = document.querySelector('.hidden-logo');
    const headerLogo = document.querySelector('.header-logo');

    if(!logo || !headerLogo) return;

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) {
                headerLogo.style.display = 'block';
            } else {
                headerLogo.style.display = 'none';
            }
        });
    }, { threshold: 0 });

    logo.getBoundingClientRect().top < 0 ? headerLogo.style.display = 'block' : headerLogo.style.display = 'none';
    setTimeout(() => {
        observer.observe(logo);
    }, 1200);
});
